module.exports = __webpack_public_path__ + "img/NX.b66e5c49.png";